import React, { useState } from 'react';
import {
    getProgressPaginationData,
    getWeeklySummary
} from '../controller/Pagination';
import './Progress.css';

/**
 * Project progress component of the AnchorTech Solutions React Website.
 * Pagination navigation of weekly project progress and then group member task progress in the format of weekly reports.
 * Defaults to the current week of project progress, but any week of progress can be dynamically visualized.
 * @param {Object[]} formattedProjectTaskData API-fetched group project management data modified to weekly report format
 */
function Progress({ formattedProjectTaskData }) {
    const [weeks, assignees, currentWeekNumber] = getProgressPaginationData();
    const [weekNumber, setWeekNumber] = useState(currentWeekNumber);
    const [assigneeNumber, setAssigneeNumber] = useState(0);

    const changeProgressWeek = (newWeekNumber) => {
        setWeekNumber(newWeekNumber);
    };

    const changeAssignee = (newAssigneeNumber) => {
        setAssigneeNumber(newAssigneeNumber);
    };

    const getSummary= (weekNumber) => {
        return getWeeklySummary(weekNumber);
    }

    const pullRequestReviewPrefix = 'PR REVIEW: ';

    const isPullRequestReviewer = (task, selectedAssignee) => {
        for (let pr in task.pullRequests)
            for (let reviewer in task.pullRequests[pr].reviewers)
                if (task.pullRequests[pr].reviewers[reviewer]['name'] === selectedAssignee)
                    return true;
        return false;
    }

    const getPullRequestReviewTime = (task, selectedAssignee) => {
        for (let pr in task.pullRequests)
            for (let reviewer in task.pullRequests[pr].reviewers)
                if (task.pullRequests[pr].reviewers[reviewer]['name'] === selectedAssignee)
                    return task.pullRequests[pr].reviewers[reviewer]['reviewTime'];
    }

    return (
        <div>
            <h1 className='h1Progress'>Project Progress</h1>
            <div className="Pagination TopPagination">
                { weeks.map((weekName, i) => (
                    <button key={ i }
                            onClick={ () => changeProgressWeek(i) }
                            disabled={ i > currentWeekNumber }>
                        { weekName }
                    </button>
                ))}
            </div>
            <div className='SummaryParent'>
                <p className='Summary'>{ getSummary(weekNumber) }</p>
            </div>
            <h2 className='h2Progress'>Progress Burn Up Graph</h2>
            <div>
                <p className='pProgress'>TODO: graph(s) go here...</p>
            </div>
            <h2 className='h2Progress'>{ weeks[weekNumber] } Task Progress</h2>
            <div className="Pagination">
                { assignees.map((assigneeName, i) => (
                    <button key={ i } onClick={ () => changeAssignee(i) }>
                        { assigneeName }
                    </button>
                ))}
            </div>
            <div className="TaskDataList">
                { Array.isArray(formattedProjectTaskData) ? (
                    <div>
                        { formattedProjectTaskData.map((task, i) => (
                            <div key={ i } className="TaskDataItem">
                                { task.sprints.includes(weekNumber) &&
                                    (task.assignee === assignees[assigneeNumber].toUpperCase() ||
                                        isPullRequestReviewer(task, assignees[assigneeNumber].toUpperCase())) ? (
                                    <p>
                                        { ' - ' }
                                        <React.Fragment>
                                            <span className="Assignee">[{ assignees[assigneeNumber].toUpperCase() }]</span>{' '}
                                        </React.Fragment>
                                        { task.assignee === assignees[assigneeNumber].toUpperCase() && task.peers ? (
                                            <React.Fragment>
                                                <span className="Assignee">[{ task.peers }]</span>{' '}
                                            </React.Fragment>
                                        ) : '' }
                                        { task.assignee === assignees[assigneeNumber].toUpperCase() ? (
                                            task.labelWhat.map((labelWhat, j) => (
                                            <React.Fragment key={ j }>
                                                <span className="LabelWhat">[{ labelWhat }]</span>{' '}
                                            </React.Fragment>
                                        ))) : (
                                            <span className="LabelWhat">[OTHER] [TEST] </span>
                                        ) }
                                        { task.labelStatus.map((labelStatus, j) => (
                                            <React.Fragment key={ j }>
                                                <span className="LabelStatus">[{ labelStatus }]</span>{' '}
                                            </React.Fragment>
                                        ))}
                                        { task.assignee === assignees[assigneeNumber].toUpperCase() ? (
                                            task.title
                                        ) : (
                                            pullRequestReviewPrefix + task.title
                                        )}
                                        { ' ' }
                                        { task.assignee === assignees[assigneeNumber].toUpperCase() ? (
                                            task.time
                                        ) : (
                                            getPullRequestReviewTime(task, assignees[assigneeNumber].toUpperCase())
                                        )}
                                        { ' - ' }
                                        { task.url &&
                                            <a href={ task.url } target="_blank" rel="noopener noreferrer">
                                                { task.assignee === assignees[assigneeNumber].toUpperCase() ? (
                                                    'Issue'
                                                ) : (
                                                    'Pull Request'
                                                )}
                                            </a>
                                        }
                                    </p>
                                    ) : ''}
                            </div>
                        ))}
                    </div>
                ) : (
                    { formattedProjectTaskData }
                )}
            </div>
      </div>
    );
}

export default Progress;
